<template>
  <el-dialog :title="!id?'新增发票':'编辑发票'" :visible="true" width="820px" center :before-close="cancel" :destroy-on-close="false" :close-on-click-modal="false">
    <div style="background: #f1f1f1;padding: 10px 0;border-radius: 4px;width:80%;margin:0 auto;">
      <div class="address-border">
        <span class="span-left"><i>*</i>发票类型：</span>
        <el-select v-model="fpType">
          <el-option label="普通发票" :value="1" />
          <el-option label="增值税发票" :value="2" />
        </el-select>
      </div>
      <div class="address-border">
        <span class="span-left"><i>*</i>公司名称：</span>
        <input v-if="fpType===1" v-model="fpCommonCompanyName" type="text" name="" placeholder="公司名称">
        <input v-else-if="fpType===2" v-model="fpCompanyName" type="text" name="" placeholder="公司名称">
      </div>
      <div class="address-border">
        <span class="span-left"><i>*</i>纳税人识别号：</span>
        <input v-model="fpIdCode" type="text" name="" placeholder="请输入纳税人识别号">
      </div>
      <div class="address-border" v-if="fpType===2">
        <span class="span-left"><i>*</i>公司详细地址：</span>
        <input v-model="fpAddress" type="text" name="" placeholder="为保证顺利收货，请写明详细收货地址">
      </div>
     <div class="address-border" v-if="fpType===2">
       <span class="span-left"><i>*</i>公司账号：</span>
        <input v-model="fpBankCode" type="text" placeholder="请输入公司账号"/>
      </div>
      <div class="address-border" v-if="fpType===2">
        <span class="span-left"><i>*</i>公司开户行：</span>
        <input v-model="fpBankType" type="text" name="" placeholder="公司开户行" maxlength="11">
      </div>
<!--      <div class="address-border" v-if="fpType===2">
        <span class="span-left">税点：</span>
        <input v-model="tax_point" type="text" name="" placeholder="税点">
      </div>-->
      <div class="address-border" v-if="fpType===2">
        <span class="span-left"><i>*</i>公司电话：</span>
        <input v-model="fpPhone" type="text" name="" placeholder="公司电话">
      </div>

      <div style="text-align:center;">
        <span @click="saveAddress" class="address-button">保存</span>
        <span @click="cancel" class="address-button">取消</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {Message, MessageBox} from 'element-ui';
import { getInvoiceDetail, addInvoiceData,updateInvoiceData } from '@/assets/request/InvoiceRequest';

export default {
  name: "EditInvoice",
  data:()=>({
    fpAddress:'',
    fpBankCode:'',
    fpBankType:'',
    tax_point:'',
    fpIdCode:'',
    fpPhone:'',
    fpType:1,
    fpCompanyName:'',
    fpCommonCompanyName:'',
  }),
  props:{
    id:{
      type:Number,
      default:0
    }
  },
  methods:{
    saveAddress(){
      if((this.fpType==1 && !this.fpCommonCompanyName.trim()) || (this.fpType==2 && !this.fpCompanyName.trim())) return MessageBox.alert('公司名称必填');
      if(!this.fpIdCode) return MessageBox.alert('纳税人识别号不能为空');
      let data = {
        fpType:this.fpType,
        fpCompanyName:this.fpType===1?this.fpCommonCompanyName:this.fpCompanyName,
        fpIdCode:this.fpIdCode,
      };
      if(this.fpType==2 && !this.fpAddress.trim()) return MessageBox.alert('公司详细地址不能为空');
      if(this.fpType==2 && !this.fpBankCode.trim()) return MessageBox.alert('公司账号不能为空');
      if(this.fpType==2 && !this.fpBankType.trim()) return MessageBox.alert('公司开户行不能为空');
      if(this.fpType==2 && !this.fpPhone.trim()) return MessageBox.alert('公司电话不能为空');
      data = {
        ...data,
        fpAddress:this.fpAddress,
        fpPhone:this.fpPhone,
        fpBankType:this.fpBankType,
        fpBankCode:this.fpBankCode,
        invoiceId:this.id,
      };
      if(!this.id){
        addInvoiceData({
          fpType:this.fpType,
          fpCompanyName: this.fpType===1?this.fpCommonCompanyName:this.fpCompanyName,
          fpIdCode:this.fpIdCode,
          fpAddress:this.fpAddress,
          fpPhone:this.fpPhone,
          fpBankType:this.fpBankType,
          fpBankCode:this.fpBankCode,
        }).then(r=>{
          if(r.status!==200) return alert(r.statusText);
          const bool = Number(r.data.code)===200;
          Message[bool?'success':'error'](r.data.msg);
          this.$emit('save');
        }).catch(r=>{
          alert('修改异常');
          console.trace({
            message:'修改异常',
            r
          });
        });
      }
      else{
        updateInvoiceData(data).then(r=>{
          console.log(r);
          if(r.status!==200) return alert(r.statusText);
          const bool = Number(r.data.code)===200;
          Message[bool?'success':'error'](r.data.msg);
          this.$emit('save');
        }).catch(r=>{
          alert('修改异常');
          console.trace({
            message:'修改异常',
            r
          });
        });
      }
    },
    cancel(){
      this.$emit('cancel');
    },
    getDetail(id){
      if(!id) return;
      getInvoiceDetail(id).then(r=>{
        if(r.status!==200) return alert(r.statusText);
        const bool = Number(r.data.code)===200;
        if(!bool) Message.error(r.data.msg);
        const { fpAddress, fpBankCode, fpBankType, tax_point, fpIdCode, fpPhone, fpType, fpCommonCompanyName, fpCompanyName } = r.data.data[0];
        this.fpAddress = fpAddress;
        this.fpBankCode = fpBankCode;
        this.fpBankType = fpBankType;
        this.tax_point = tax_point;
        this.fpIdCode = fpIdCode;
        this.fpPhone = fpPhone;
        this.fpType = Number(fpType);
        this.fpCompanyName = fpCompanyName;
        this.fpCommonCompanyName = fpCommonCompanyName;
      }).catch(r=>{
        alert('获取发票详情异常');
        console.trace({
          message:'获取发票详情异常',
          r
        });
      });
    },
  },
  created() {
    Object.assign(this.$data,this.$options.data.call(this));
    this.getDetail(this.id);
  }
}
</script>

<style scoped lang="scss">
.el-select-dropdown__item.selected{
  color: var(--JN_mainColor);
}
.address-button{
  width: 70px;
  background: var(--JN_mainColor);
  color: #fff;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
  margin: 10px auto;
  text-align: center;
  display: inline-block;
}
.address-border{
  width: 550px;
  margin: 12px auto;
  input {
    width: 428px;
    height: 34px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius:4px;
    &[type="checkbox"] {
      width: 20px;
      height: 20px;
      padding: 10px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius:4px;
      vertical-align: middle;
    }
  }
  select {
    border: 1px solid #ccc;
    height: 34px;
    font-size: 14px;
    width: 140px;
    border-radius:4px;
  }
}
.span-left {
  height: 38px;
  width: 105px;
  line-height: 36px;
  display: inline-block;
  text-align: left;
  position: relative;
  &>i{
    position: absolute;
    top: 0;
    left: -1em;
    color:#f00;
    margin-right: 6px;
  }
}
input{
  transition: all .2s linear 0s;
  &:hover,&:focus{
    border-color: var(--JN_mainColor);
  }
}
</style>